import React from "react";
import Story from "./story";
import Entity from "../Entity";

class ProjectStory extends Story {
  constructor (props) {
    super(props);

    this.state = {
      story: props.story,
      entity: props.story.entity,
      payload: props.story.payload,
      project: props.story.payload[0]
    };
  }

  render () {
    const tracking = "?ad_medium=myad_feed&ad_name=project-story";
    const project = this.state.project;
    const subtitleMsg = I18n.t("jslibrary.stream.because_follow");
    return (
      <div
        className="afd-story"
        data-insights-category="myad-feed"
        data-insights-label="project-story"
        data-insights-value={this.project.url}
      >
        <header className="afd-story__content">
          <h2 className="afd-title-big afd-title-big--bmargin-big afd-container-padding--m">
            <a className="afd-title--black-link" href={project.url + tracking}>
              {project.title}
            </a>
          </h2>
          <div className="date-publication afd-mobile-margin">
            {this.formatDate(this.state.story.created_at)} | {subtitleMsg} <Entity entity={this.state.entity} />
          </div>
        </header>

        <div className="afd-story__content">
          <figure className="afd-figure">
            <a href={project.url + tracking}>
              <img src={project.image} className="afd-figure__image" />
            </a>
          </figure>
        </div>
      </div>
    );
  }
}

export default ProjectStory;
